module.exports = __webpack_public_path__ + "img/no-data.2ab9ffc9.svg";